import React from 'react';
import { Box, Button, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { InternalButtonBar } from '../../../layout/components';
import DatePickerDobMasked from '../../../../common/components/DatePicker/DatePickerDobMasked';
import moment from 'moment/moment';
import { connect } from 'react-redux';
import formatDateTime from '../../../../helpers/formatDateTime';

const CustomerList = ({ applyFilter, goTo }) => {
  const formatAddress = (cell, row) => {
    return row.address.postcode;
  };

  const handleRowClick = (row) => {
    goTo('/customers/' + row.id);
  };

  const handleFilterNameUpdate = (event) => {
    applyFilter('customers', 'filter[name]', event.target.value);
  };

  const handleFilterEmailUpdate = (event) => {
    applyFilter('customers', 'filter[email]', event.target.value);
  };

  const handleFilterPostcodeUpdate = (event) => {
    applyFilter('customers', 'filter[address.postcode]', event.target.value);
  };

  const handleFilterDOBUpdate = (event) => {
    const dateOfBirth = moment(event.target.value, 'DD/MM/YYYY').utcOffset(0, true);
    const dob = dateOfBirth.isValid() ? dateOfBirth.format() : '';

    applyFilter('customers', 'filter[dob]', dob);
  };

  return (
    <div>
      <Box>
        <Row>
          <Col sm={4}>
            <ControlLabel className="filter-label">Name</ControlLabel>
            <FormControl onChange={handleFilterNameUpdate} />
          </Col>
          <Col sm={4}>
            <ControlLabel className="filter-label">Email</ControlLabel>
            <FormControl onChange={handleFilterEmailUpdate} />
          </Col>
          <Col sm={2}>
            <ControlLabel className="filter-label">Postcode</ControlLabel>
            <FormControl onChange={handleFilterPostcodeUpdate} />
          </Col>
          <Col sm={2}>
            <ControlLabel className="filter-label">DOB</ControlLabel>
            <DatePickerDobMasked
              input={{
                onChange: handleFilterDOBUpdate,
              }}
            />
          </Col>
        </Row>
      </Box>

      <Box>
        <Row>
          <Col sm={12}>
            <DataTable
              source="/local/customers"
              name="customers"
              showTotal
              autoFilterType="filter[visible]"
              autoFilters={[{ type: 'filter[visible]', value: true }]}
              onRowSelect={handleRowClick}
            >
              <TableHeaderColumn dataField="id" isKey hidden />

              <TableHeaderColumn dataField="customer_name" width={'300px'}>
                Name
              </TableHeaderColumn>

              <TableHeaderColumn dataField="email" width={'200px'} dataSort>
                Email
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="address"
                width={'100px'}
                dataFormat={formatAddress}
              >
                Postcode
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="created_at"
                width={'100px'}
                dataFormat={formatDateTime}
                dataSort
              >
                Customer Since
              </TableHeaderColumn>
            </DataTable>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['customer.create'],
                  button: (
                    <Button
                      link
                      to="/customers/new"
                      className="pull-right"
                      bsStyle="primary"
                      label="new customer"
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Box>
    </div>
  );
};

export default connect(
  null,
  {
    goTo: push,
    applyFilter: applyFilter,
  },
)(CustomerList);
